<div class="form-item-label-section">
  <label [attr.for]="controlId" [id]="id">{{ labelText }}</label>
  <span class="required-star" *ngIf="required" aria-hidden="true">*</span>
</div>
